/**
 * bl-disclosure.js — shared expand/collapse primitive.
 *
 * Markup contract (see snippets/bl-disclosure.liquid):
 *
 *   <details class="bl-disclosure" data-bl-component="disclosure"
 *            data-bl-disclosure="faq-1" data-bl-disclosure-group="faq">
 *     <summary class="bl-disclosure__summary" aria-expanded="false"> ... </summary>
 *     <div class="bl-disclosure__panel" id="..."> ... </div>
 *   </details>
 *
 * Built on <details>/<summary> so it works with zero JavaScript: open/close,
 * Enter and Space, and correct semantics are native. This module only adds the
 * behaviour the platform does not give us:
 *
 *   - aria-expanded mirrored on the summary for older screen readers
 *   - single-open accordions via data-bl-disclosure-group
 *   - Escape closes and returns focus to the summary (opt out with
 *     data-bl-disclosure-escape="false")
 *   - bl:disclosure:toggle events for companion apps
 *   - clean teardown on Theme Editor section re-render (registry handles it)
 */

const BL = window.BrightLeaf;

BL.components.register('disclosure', (root, { events }) => {
  const summary = root.querySelector(':scope > summary');
  if (!summary) return undefined;

  const group = root.dataset.blDisclosureGroup || null;
  const escapeCloses = root.dataset.blDisclosureEscape !== 'false';
  const name = root.dataset.blDisclosure || summary.textContent.trim();

  const sync = () => summary.setAttribute('aria-expanded', String(root.open));
  sync();

  const onToggle = () => {
    sync();

    if (root.open && group) {
      document
        .querySelectorAll(`details[data-bl-disclosure-group="${CSS.escape(group)}"][open]`)
        .forEach((other) => {
          if (other !== root) other.open = false;
        });
    }

    events.emit('bl:disclosure:toggle', { name, group, open: root.open, el: root });
  };

  const onKeydown = (event) => {
    if (event.key !== 'Escape' || !escapeCloses || !root.open) return;
    event.stopPropagation();
    root.open = false;
    summary.focus();
  };

  root.addEventListener('toggle', onToggle);
  root.addEventListener('keydown', onKeydown);

  return () => {
    root.removeEventListener('toggle', onToggle);
    root.removeEventListener('keydown', onKeydown);
  };
});
